export enum DataBoundary {
  RestOfWorld = 0,
  EuropeanUnion = 1,
}

export function getDataBoundaryForRegion(region: string): DataBoundary {
  const upperRegion = region.toUpperCase();
  if (
    upperRegion === "CHC" ||
    upperRegion === "DEC" ||
    upperRegion === "EUC" ||
    upperRegion === "EURPPC" ||
    upperRegion === "FRC" ||
    upperRegion === "SEC" ||
    upperRegion === "NOC"
  ) {
    return DataBoundary.EuropeanUnion;
  }

  return DataBoundary.RestOfWorld;
}
